export default "__VITE_ASSET__B9S2bf_g__"